"use client";

import { useEffect, useState } from "react";
import { EventsData } from "../types";
import { categorizeEvents } from "../utils/eventUtils";
import Image from "next/image";
import Link from "next/link";
import ScrollAnimation from "./ScrollAnimation";

export default function NextEventSection() {
  const [data, setData] = useState<EventsData | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch(`/api.php?action=get_events&t=${new Date().getTime()}`)
      .then((res) => res.json())
      .then((jsonData) => {
        setData(jsonData);
        setLoading(false);
      })
      .catch((err) => {
        console.error("Failed to load events", err);
        setLoading(false);
      });
  }, []);

  if (loading || !data) {
    return (
      <section className="section-block concert-dates text-center min-h-[400px] flex items-center justify-center" id="termine">
        <div className="animate-pulse opacity-50">Lade nächsten Termin...</div>
      </section>
    );
  }

  const { upcoming } = categorizeEvents(data?.events || []);
  const nextEvent = upcoming.length > 0 ? upcoming[0] : null;

  return (
    <section className="section-block concert-dates text-center" id="termine">
      <ScrollAnimation animation="fade-in">
        <h2>Nächster Termin</h2>
      </ScrollAnimation>
      
      {nextEvent ? (
        <ScrollAnimation animation="slide-up" delay={200}>
          <div className="next-event-card flex flex-col items-center gap-8 p-10 rounded-2xl shadow-2xl border border-accent/30 bg-gradient-to-br from-primary/80 to-secondary/80 backdrop-blur-md max-w-3xl mx-auto">
            {data.config.showNextEventPoster && data.config.posterImage && (
              <div className="plakat-section-poster flex-shrink-0 max-w-[300px] w-full flex justify-center">
                <div className="plakat-cover-poster rounded-lg overflow-hidden shadow-lg hover:scale-105 transition-transform w-full max-w-[280px]">
                  <Image 
                    src={data.config.posterImage} 
                    alt="Plakat" 
                    width={300} 
                    height={450} 
                    className="w-full h-auto"
                    unoptimized 
                  />
                </div>
              </div>
            )}
            <div className="event-info flex-1 text-center flex flex-col items-center w-full">
              <h3 className="text-4xl mb-4 shadow-accent/50">{nextEvent.event}</h3>
              <p className="text-xl mb-4 font-serif italic">Datum: {nextEvent.date}</p>
              <p className="text-xl mb-6 font-serif italic">Ort: {nextEvent.location}</p>
              {nextEvent.tickets.url && nextEvent.tickets.url.trim() !== "" ? (
                <Link 
                  href={nextEvent.tickets.url} 
                  target="_blank" 
                  className="btn-secondary"
                >
                  {nextEvent.tickets.text}
                </Link>
              ) : (
                <span className="btn-secondary cursor-default">{nextEvent.tickets.text}</span>
              )}
            </div>
          </div>
        </ScrollAnimation>
      ) : (
        <div className="p-8 bg-white/5 rounded-xl border border-white/10 max-w-3xl mx-auto">
          <p className="text-xl italic opacity-80">Aktuell steht der nächste Termin noch nicht fest.</p>
        </div>
      )}
    </section>
  );
}
